import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
var CodeBlock = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CodeBlock, _React$Component);
  function CodeBlock() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = CodeBlock.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("pre", {
      className: "codeblock tui-language-javascript"
    }, /*#__PURE__*/React.createElement("code", {
      dangerouslySetInnerHTML: {
        __html: this.props.code
      }
    }));
  };
  return CodeBlock;
}(React.Component);
export default CodeBlock;